import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const NotFound = lazy(() => import('../pages/NotFound'));
const PrivateHealthInsurancePage = lazy(() => import('../pages/private-health-insurance/page'));
const GroupHealthInsurancePage = lazy(() => import('../pages/group-health-insurance/page'));
const MedicareKerrvillePage = lazy(() => import('../pages/medicare-kerrville/page'));
const DentalInsurancePage = lazy(() => import('../pages/dental-insurance/page'));

// ... existing code ...

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/private-health-insurance-kerrville-tx',
    element: <PrivateHealthInsurancePage />,
  },
  {
    path: '/group-health-insurance-kerrville-tx',
    element: <GroupHealthInsurancePage />,
  },
  {
    path: '/medicare-kerrville-tx',
    element: <MedicareKerrvillePage />,
  },
  {
    path: '/dental-insurance-kerrville-tx',
    element: <DentalInsurancePage />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
